<template>
  <v-container class="fill-height" style="opacity: 0.9" fluid>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      top
      color="white"
    ></v-progress-linear>
    <v-snackbar
      :timeout="snackbar.timeout"
      v-model="snackbar.show"
      top
      :color="snackbar.color"
      elevation="24"
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" v-bind="attrs" @click="snackbar.show = false"> Close </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="dialog.show" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialog.title }}</span>
        </v-card-title>
        <v-card-text v-if="dialog.messages">
          <ol>
            <li v-for="message in dialog.messages" :key="message">
              {{ message }}
            </li>
          </ol>
        </v-card-text>
        <v-card-text v-if="dialog.message">
          <div>
            <b>Registered Name :</b>
            {{ dialog.message.registerName }}
            <br />
            <b>Registeration Date :</b>
            {{ dialog.message.registerDate }}
            <br />
            <b>Registered By :</b>
            {{ dialog.message.registeredBy }}
            <br />
            <b>Star Name :</b>
            {{ dialog.message.starName }}
            <br />
            <b>Registry Key :</b>
            {{ dialog.message.registryKey }}
            <br />
            <b>Greeting Message :</b>
            {{ dialog.message.greetMessage }}
            <br />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="dialog.message"
            color="primary darken-1"
            text
            :href="'https://software.space-registry.org/registry/' + dialog.message.registryKey"
            target="_blank"
          >
            View In Software
          </v-btn>
          <v-btn color="primary darken-1" text @click="dialog.show = false"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-col cols="12" sm="12" md="10">
        <v-card class="elevation-12">
          <v-toolbar color="primary" flat>
            <v-toolbar-title>{{ $t('Bulk Registry') }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="formBulk">
              <v-row align="center" justify="center">
                <v-col>
                  <v-file-input
                    v-model="csvFile"
                    show-size
                    counter
                    accept="text/csv"
                    :label="$t('Choose a CSV...')"
                  ></v-file-input>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-btn color="primary" href="stars.csv" download text x-large>
                  <v-icon left>mdi-cloud-download-outline</v-icon>
                  {{ $t('Download Format') }}
                </v-btn>
              </v-row>
              <v-row>
                <v-col>
                  <div class="subtitle-2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-icon>mdi-alert-outline</v-icon>
                          {{ $t('Instructions:') }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ $t("Click 'Download Format' to download csv format!") }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          {{ $t('Fill in required details (DO NOT ALTER HEADER ROW)') }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          {{ $t('Choose CSV file above') }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          {{ $t("Click 'Bulk Register' to start registration process!") }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-text v-if="currentStar">Registering... {{ currentStar }}</v-text>
            <v-spacer></v-spacer>
            <v-btn @click="csvUpload" color="primary">{{ $t('Bulk Register') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import VuePapaParse from 'vue-papa-parse'
  import swh from '@/assets/js/sw_helper'
  import { saveRegistry } from '../services/registryService'
  import { getSkySources } from '../services/skySourceService'

  Vue.use(VuePapaParse)

  export default {
    props: {
      source: String,
    },
    data() {
      return {
        snackbar: {
          show: false,
          timeout: 2000,
          color: 'primary',
          message: '',
        },
        dialog: {
          show: false,
          title: '',
          messages: '',
          message: '',
        },
        loading: false,
        currentStar: '',
        csvFile: undefined,
      }
    },
    methods: {
      async registerStarObj(starObj) {
        try {
          const { data } = await saveRegistry(starObj)
          this.currentStar = data.registryKey
          console.log(data)
          return data
        } catch (error) {
          this.currentStar = error.source.registryKey
          throw error
        }
      },

      csvUpload() {
        var that = this
        if (!this.csvFile) {
          this.showSnackbar('warning', 'Please select a CSV file!')
          return
        }

        var countSuccess = 0,
          countFailed = 0,
          totalRows = 0,
          failedArr = []
        this.loading = true

        this.$papa.parse(this.csvFile, {
          worker: true,
          header: true,
          skipEmptyLines: true,
          step: function (result) {
            totalRows += 1
            const starObj = {
              registerDate: result.data.registerDate,
              registerName: result.data.registerName,
              registeredBy: result.data.registeredBy || '',
              registryKey: result.data.registryKey,
              greetMessage: result.data.greetings || '',
              starName: result.data.starName,
            }
            that
              .registerStarObj(starObj)
              .then((res) => {
                console.log(res)
                countSuccess += 1

                that.handleErrors(totalRows, countSuccess, countFailed, failedArr)
              })
              .catch((error) => {
                countFailed += 1
                failedArr.push(error)

                that.handleErrors(totalRows, countSuccess, countFailed, failedArr)
              })
          },
        })
      },

      handleErrors(total, success, fails, failures) {
        if (success + fails - total == 0) {
          console.log('stopped loading...')
          this.showSnackbar(
            'primary',
            `${success} out of ${total} stars registered! ${fails} failed!`
          )
          this.loading = false
          this.currentStar = ''
          this.showDialog(
            `Error Details: ${fails} failed!`,
            failures.map((obj) => {
              return 'Registry: ' + obj.source.registryKey + ' - ' + obj.original
            }),
            true
          )
        }
      },

      showSnackbar(type, message) {
        this.snackbar.color = type
        this.snackbar.message = message
        this.snackbar.show = true
      },

      showDialog(title, message, type = false) {
        console.log(type)
        if (type) {
          this.dialog.messages = message
          this.dialog.message = ''
        } else {
          this.dialog.message = message
          this.dialog.messages = ''
        }

        this.dialog.title = title
        this.dialog.show = true
      },
    },
    mounted: async function () {
      const { data } = await getSkySources(true)
      this.stars = data
    },
    watch: {
      date(val) {
        console.log(val)
        this.dateFormatted = swh.formatDate(this.date)
      },
    },
  }
</script>

<style></style>
